import ZlbConfirm from '@/components/ZlbConfirm';
import { reqPersonalBankList } from 'src/routes/BankCard/services';
import {
  deleteBankInfo,
  deleteSubBankInfo,
  getSubBankList,
  getZSBankList,
  getZSSubBankList,
  queryBankCode,
  saveMainBank,
  saveSubBank,
} from '../services';

/**
 * 请求错误信息统一处理
 * @param res
 */
const responseErrorHandle = res => {
  const { success, statusText, message } = res;
  if (!success) {
    ZlbConfirm({
      title: statusText || message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

export default {
  namespace: 'bankInfo',
  state: {
    bankList: [],
    bankZSList: [],
    bankZSBranchList: [],
  },
  effects: {
    // 银行列表
    *getMainBankList({ payload }, { call, put }) {
      const res = yield call(reqPersonalBankList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 支行列表
    *getSubBankList({ payload }, { call, put }) {
      const res = yield call(getSubBankList, payload);
      responseErrorHandle(res);
      return res;
    },
    // 获取银行列表
    *getBankList({ payload }, { call, put }) {
      const res = yield call(reqPersonalBankList, payload);
      yield put({
        type: 'update',
        payload: {
          bankList: res.result || [],
        },
      });
      return res;
    },
    // 查询浙商银行列表
    *getZSBankList({ payload }, { call, put }) {
      const res = yield call(getZSBankList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          bankZSList: res.result || [],
        },
      });
      return res;
    },
    // 查询浙商支行列表
    *getZSSubBankList({ payload }, { call, put }) {
      const res = yield call(getZSSubBankList, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          bankZSBranchList: res.result || [],
        },
      });
      return res;
    },
    // 新增大行
    *saveMainBank({ payload }, { call }) {
      const res = yield call(saveMainBank, payload);
      responseErrorHandle(res);
      return res;
    },
    // 新增支行
    *saveSubBank({ payload }, { call }) {
      const res = yield call(saveSubBank, payload);
      responseErrorHandle(res);
      return res;
    },
    // 查询银行行号
    *queryBankCode({ payload }, { call }) {
      const res = yield call(queryBankCode, payload);
      responseErrorHandle(res);
      return res;
    },
    // 删除银行
    *deleteBankInfo({ payload }, { call }) {
      const res = yield call(deleteBankInfo, payload);
      responseErrorHandle(res);
      return res;
    },
    // 删除支行
    *deleteSubBankInfo({ payload }, { call }) {
      const res = yield call(deleteSubBankInfo, payload);
      responseErrorHandle(res);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
